import { module as m } from 'modujs';

export default class extends m {
    constructor(m) {
        super(m);
    }

    /**
     * INIT
     */
    init() {}

    /**
     * START
     */
    start() {}

    /**
     * DESTROY
     */
    destroy() {}
}
